import Cookies from 'js-cookie';
import validatorDirective from '../directives/form/validator';
import recaptchaDirective from '../directives/form/recaptcha';
import floatLabel from '../directives/form/float-label';

let tempId = 0

export default function hsFormSection() {

  const forms = [...document.querySelectorAll('form.hs-form')];

  forms.forEach(async $form => {
    const hapiKey = $form.getAttribute('data-hs-api-key');
    const portalId = $form.getAttribute('data-hs-portal-id');
    const formGuid = $form.getAttribute('data-hs-form-guid');
    const recaptchaCallback = $form.getAttribute('data-sw-temp-recaptcha');
    const recaptchaSiteKey = $form.getAttribute('data-sw-recaptcha-sitekey');

    let $cols = document.createElement('div');
    $cols.classList.add('columns', '-h-gap-smx', '-v-gap-smx');
    let form;

    const hubspotFormEndpoint = '/hubspot-form';
    const formData = new FormData();

    formData.append(csrfTokenName, csrfTokenValue);
    formData.append('formGuid', formGuid);

    $form.append($cols);

    // $form.addEventListener('submit', handleFormSubmit);

    const response = await fetch(hubspotFormEndpoint, {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    });

    try {
      form = await response.json();

      let $lastCol;
      let richTextFlag;
      let legal = form.legalConsentOptions;

      // form.metaData.forEach(e => {
      //   if (e.name === 'legalConsentOptions') {
      //     legal = {
      //       name: e.name,
      //       value: JSON.parse(e.value)
      //     }
      //   }
      // });

      // form.fieldGroups.forEach(g => {

      //   console.log(g);

        

      //   if (fields && fields.length) {

      //     console.log(fields);

      //   }

      // });

      form.fieldGroups.forEach(group => {

        let $col;

        let groupFields = group.fields;
        let groupFieldsLength = (groupFields && groupFields.length) ? groupFields.length : 0;
        let groupRichText = group.richText;

        let widthClass = `@desk-${groupFieldsLength === 2 ? '6' : '12'}`;

        if (groupFieldsLength > 0) {

          groupFields.forEach(field => {

            // console.log(field);

            $col = document.createElement('div');
            $col.classList.add('column', widthClass);
            $cols.append($col);
            richTextFlag = false;

            if (field.fieldType === 'single_line_text' 
                || field.fieldType === 'email'
                || field.fieldType === 'phone') {
              $col.append(getInputField(field));
            } else if (field.fieldType === 'multi_line_text') {
              $col.append(getTextareaField(field));
            } else if (field.fieldType === 'single_checkbox') {
              $col.append(getRadioSelectField(field));
            } else if (field.fieldType === 'multiple_checkboxes') {

              widthClass = '6';

              $col.append(getCheckboxField(field));
            } else if (field.fieldType === 'dropdown') {
              $col.append(getRadioSelectField(field));
            }
          });
        }

        if (groupRichText) {

          if (richTextFlag) {
            $col = $lastCol;
          } else {
            $col = document.createElement('div');
            $col.classList.add('column', widthClass, 'text');
            $cols.append($col);
          }

          $col.append(createElementFromHTML(`
						<div class="container -width-9 -align-left">
							<div class="text +text-left">
								${groupRichText}
							</div>
						</div>
					`));

          richTextFlag = true
          $lastCol = $col
        }

        $lastCol = $col
      });

      if (legal) {

        // console.log(legal);

        let checkboxes = legal.communicationsCheckboxes;
        let consentText = reformatText(legal.communicationConsentText, 'h4');

        let privacyText = reformatText(legal.privacyText, 'h4') + reformatText(legal.consentToProcessText, 'h4');

        $cols.append(getConsentField(checkboxes, consentText, privacyText));

        $cols.append(createElementFromHTML(`<input type="hidden" name="legalConsentOptions[communicationConsentText]" value="${legal.communicationConsentText}">`));
        $cols.append(createElementFromHTML(`<input type="hidden" name="legalConsentOptions[consentToProcessText]" value="${legal.consentToProcessText}">`));
      }

      // Add submit button with recaptcha if defined
      $cols.append(createElementFromHTML(`
        <div class="column @desk-12">
          <button
            type="submit" 
            class="button -submit ${(recaptchaCallback.length && recaptchaSiteKey.length) ? ' g-recaptcha' : ''}"
            data-sitekey="${recaptchaSiteKey}"
            data-callback="${recaptchaCallback}"
          >
            Submit Enquiry
          </button>
        </div>
      `));

      // Initialize the new sw-float-labels
      floatLabel(document.body);

      // if (Cookies.get('hubspotutk')) {
      //   $form.append(createElementFromHTML(`<input type="hidden" name="cookieValue" value="${Cookies.get('hubspotutk')}" />`));
      // }

      checkCookie($form);

      $form.setAttribute('data-sw-validator', 'true');
      $form.setAttribute('data-sw-recaptcha', recaptchaCallback);

      // Validation/recap
      validatorDirective();
      recaptchaDirective();

      // Hook up recaptcha
      if (recaptchaCallback.length && window.loadRecaptcha) window.loadRecaptcha();

      // Drift - parse out the form data and stage it for drift (this is awful)
      if (window.drift) {
        window.hsFormWillSubmit = event => {
          let f = new FormData($form);
          let _data = {};
          for (var [key, value] of f.entries()) { 
            if (key.includes('formData[')) {
              let fn = key.split('formData[')[1].split(']')[0];
              if (key.includes('[]')) {
                let cv = [],
                ch = document.getElementsByName(`formData[${fn}][]`);
                if (ch) {
                  ch.forEach(c => {
                    if (c.checked) {
                      cv.push(c.value);
                    }
                  });
                  _data[fn] = cv.join(',');
                }
              } else {
                _data[fn] = value;
              }
            }
          }
          window.drift.api.stageFormData(_data);
          return true; // have to
        };
      }
    }
    catch (e) {
      // Could not resolve JSON for this form
    }
  });

}

function checkCookie($form) {
  if (Cookies.get('hubspotutk')) {
    $form.append(createElementFromHTML(`<input type="hidden" name="cookieValue" value="${Cookies.get('hubspotutk')}" />`));
  } else {
    setTimeout(() => checkCookie($form), 1000);
  }
}

function getInMessage(message, divider = false) {
  return `
    ${divider ? `<hr class="h-divider +t-margin-none">` : '' }
    <div class="container -width-12 -align-left">
      <div class="text +text-left +v-trim">
        ${message}
      </div>
    </div>
	`;
}

function reformatText(str, tag = 'p') {
  let newStr = str.replace('<p>', '').replace('</p>', '');

  return `<${tag}><mark>${newStr}</mark></${tag}>`
}

function getTextareaField(field) {
  tempId++

  return createElementFromHTML(`
		<div data-sw-float-label class="float-label -type-textarea is-invalid">
			<label class="float-label_label" for="${tempId}">${field.label}${field.required ? '*' : ''}</label>
			<textarea
				class="float-label_field"
				id="${tempId}"
				name="formData[${field.name}]"
				${field.required ? 'required' : ''}
				rows="4"
				spellcheck="false"
				data-sw-autosize
			></textarea>
		</div>
	`);
}

function getInputField(field) {
  tempId++
  let type = field.type
  let pattern

  if (field.name === 'email') {
    type = 'email';
  } else if (field.name === 'phone') {
    type = 'tel';
  }

  return createElementFromHTML(`
		<div data-sw-float-label class="float-label -type-text -type-input is-invalid">
			<label class="float-label_label" for="${tempId}">
				${field.label}${field.required ? '*' : ''}
			</label>
			<input
				class="float-label_field"
				id="${tempId}"
				name="formData[${field.name}]"
				type="${type}"
				${field.required ? 'required' : ''}
				${pattern ? `pattern="${pattern}"` : ''}
			/>
		</div>
	`);
}

function getRadioSelectField(field) {
  tempId++

  return createElementFromHTML(`
		<div data-sw-float-label class="float-label -type-select is-filled">
			<label class="float-label_label" for="${tempId}">
				${field.label}${field.required ? '*' : ''}
			</label>

			<select
				class="float-label_field"
				id="${tempId}"
				name="formData[${field.name}]"
				required
			>
				<option selected></option>

				${field.options.map(option => `
					<option value="${option.value}">${option.label}</option>
				`).join('')}
			</select>

			<span class="float-label_arrow">
				<i aria-hidden="true" class="icon"><svg version="1.1" id="Plus" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" enable-background="new 0 0 20 20" xml:space="preserve"><path d="M16,10c0,0.553-0.048,1-0.601,1H11v4.399C11,15.951,10.553,16,10,16c-0.553,0-1-0.049-1-0.601V11H4.601 C4.049,11,4,10.553,4,10c0-0.553,0.049-1,0.601-1H9V4.601C9,4.048,9.447,4,10,4c0.553,0,1,0.048,1,0.601V9h4.399 C15.952,9,16,9.447,16,10z"/></svg></i>
			</span>
		</div>
	`);
}

function getCheckboxField(field) {
  tempId++

  let str = '';

  field.options.forEach(option => {
    tempId++
    str += `
				<div class="cell">
						<div class="checkbox">
							<input
								id="${tempId}"
								type="checkbox"
								name="formData[${field.name}][]"
								value="${option.value}"
							/>
							<label for="${tempId}">
								<span class="checkbox_marker">
									<i aria-hidden="true" class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g id="Outline_Icons_1_"><g id="Outline_Icons"><g><polygon fill="none" stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" points="20,2.25 7.5,14.75 4,11.25      0.5,14.75 7.5,21.75 23.5,5.75    "></polygon></g></g><g id="New_icons_1_"></g></g><g id="Invisible_Shape"><rect fill="none" width="24" height="24"></rect></g></svg></i>
								</span>
								<span class="checkbox_label">${option.label}</span>
							</label>
						</div>
					</div>
				`;
  });

  return createElementFromHTML(`
		<div class="form-checkboxes">
      <div class="bar -h-gap-sm -h-align-left">
        <label class="float-label_label +t-margin-xs +b-margin-xs">
          ${field.label}
        </label>
      </div>
      <div class="grid -has-2 -h-gap-sm -h-align-left">
        ${str}
      </div>
		</div>
	`);
}

function getConsentField(options, before, after) {
  tempId++;

  let str = '';

  options.forEach(option => {
    tempId++
    str += `
				<div class="cell">
						<div class="checkbox">
							<input
								id="${tempId}"
								type="checkbox"
								name="legalConsentOptions[receive]"
								value="${option.subscriptionTypeId}"
							/>
							<label for="${tempId}">
								<span class="checkbox_marker">
									<i aria-hidden="true" class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g id="Outline_Icons_1_"><g id="Outline_Icons"><g><polygon fill="none" stroke="#000000" stroke-linejoin="round" stroke-miterlimit="10" points="20,2.25 7.5,14.75 4,11.25      0.5,14.75 7.5,21.75 23.5,5.75    "></polygon></g></g><g id="New_icons_1_"></g></g><g id="Invisible_Shape"><rect fill="none" width="24" height="24"></rect></g></svg></i>
								</span>
								<span class="checkbox_label">${option.label}</span>
							</label>
						</div>
					</div>
				`;
  });

  // console.log(options);
  // console.log(before);
  // console.log(after);
  return createElementFromHTML(`
    <div class="column @desk-12">
      <div class="+b-margin-xs">${getInMessage(before, true)}</div>
      <div class="form-checkboxes">
        <div class="grid -has-1 -h-gap-sm -h-align-left">
          ${str}
        </div>
      </div>
      <div class="+t-margin-xs">${getInMessage(after)}</div>
    </div>
	`);
}

function createElementFromHTML(htmlString) {
  let div = document.createElement('div');
  div.innerHTML = htmlString.trim();

  return div.firstChild;
}



// WEBPACK FOOTER //
// ./source/scripts/sections/hsForm.js